import { PwaEffects } from '@app/modules/pwa/ngrx/effects'
import { FavoriteEffects } from '@store/favorite/effects'
import { InteractionContextEffects } from '@store/interaction-context/effects'
import { NotificationsEffects } from '@store/notifications/effects'
import { ProfileEffects } from '@store/profile/effects'

import { InteractionEffects } from '../interactions/effects'
import { PhotoAccessEffects } from '../photo-access-requests/effects'
import { SettingsEffects } from '../settings/effects'
import { ThreadsEffects } from '../threads/effects'
import { UnreadInteractionEffects } from '../unread-interactions/effects'

export const effects = [
  PhotoAccessEffects,
  NotificationsEffects,
  SettingsEffects,
  InteractionContextEffects,
  InteractionEffects,
  UnreadInteractionEffects,
  ProfileEffects,
  ThreadsEffects,
  FavoriteEffects,
  PwaEffects,
]
